export class SifreOlusturResponseModel {
    message:string
    result:boolean
}
